export default __webpack_public_path__ + "static/labelmap-iod-b02b40c685892d3ab3b684ef007713b1.png";